import { render, staticRenderFns } from "./ReferralHomeBanner.vue?vue&type=template&id=37235055&scoped=true&"
import script from "./ReferralHomeBanner.vue?vue&type=script&lang=js&"
export * from "./ReferralHomeBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReferralHomeBanner.vue?vue&type=style&index=0&id=37235055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37235055",
  null
  
)

export default component.exports